export default {
  expandedAccordionActiveAccentColor: Styles.color.primary,
  expandedAccordionBackground: Styles.color.grey.five,
  expandedAccordionFontWeight: 'normal',
  accordionHoverBackground: Styles.color.grey.five,
  rowInversionBackgroundColor: Styles.color.primary,
  rowInversionTextColor: Styles.color.white,
  backgroundColor: Styles.color.white,
  imageWidgetCaptionAlign: 'left',
};
